import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { homepageItems } from '../../config'
import { campaignApi, CampaignEntity } from '../../../../../api/campaign'
import { QuickLinkItem } from './QuickLinkItem'

export const QuickLinks = () => {
  const { t, i18n } = useTranslation()
  const [campaigns, setCampaigns] = useState<CampaignEntity[]>([])

  useEffect(() => {
    campaignApi
      .getCampaigns()
      .then(setCampaigns)
      .catch(() => setCampaigns([]))
  }, [])

  const displayName = (c: CampaignEntity) =>
    i18n.language === 'de' ? (c.name_de || c.name) : c.name

  const staticItems = (homepageItems ?? []).map((item, index) => ({
    key: index,
    name: `HOME.${item.name}`,
    image: item.image,
    link: item.link,
    label: undefined,
    imageSrc: undefined,
    openInNewTab: undefined,
    showNewRibbon: undefined
  }))
  const campaignItems = campaigns.map((c) => ({
    key: c.id,
    name: '',
    image: undefined,
    link: c.url,
    label: displayName(c),
    imageSrc: c.icon,
    openInNewTab: true as const,
    showNewRibbon: c.show_new_banner
  }))
  const items = [...campaignItems, ...staticItems]

  return (
    <div className='quick-links-holder'>
      <div className='services-board-list-head'>
        <h2 role='heading'>{t('HOME.QUICK_LINKS')}</h2>
      </div>
      <div className='services-board-list-holder'>
        {items.map((item) => (
          <QuickLinkItem
            key={item.key}
            name={item.name}
            label={item.label}
            image={item.image}
            imageSrc={item.imageSrc}
            link={item.link}
            openInNewTab={item.openInNewTab}
            showNewRibbon={item.showNewRibbon}
          />
        ))}
      </div>
    </div>
  )
}
